import { motion } from "framer-motion";
import { Helmet } from "react-helmet-async";

const MotorcycleConsulting = () => {
  return (
    <div className="about-page">
      <>
          <Helmet>
              <title>Pro Moto - doradztwo przy zakupie motocykla</title>
              <meta
              name="description"
              content="PRO MOTO Doradztwo przy zakupie motocykla
                Ekspercki przegląd przedzakupowy i negocjacje ceny"
              />
              <link rel="canonical" href="https://promotoserwis.pl/doradztwo" />
          </Helmet>
      </>
      <section className="about-hero">
        <div className="about-hero__content">
          <motion.h1
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>Doradztwo przy zakupie motocykla</motion.h1>
          <motion.p 
            initial={{ opacity: 0, y: 80 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>Ekspercki przegląd przedzakupowy i negocjacje ceny</motion.p>
          <motion.p
            initial={{ opacity: 0, y: 90 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}>
            <strong>Marzysz o własnym motocyklu, lecz nie masz pewności, 
              czy oglądany egzemplarz jest wart swoich pieniędzy? </strong>
              Weź ze sobą zespół PRO MOTO – sprawdzimy maszynę na miejscu, 
              policzymy realne koszty przyszłych napraw, wynegocjujemy cenę, abyś wyjechał 
              sprzętem bez cienia niepokoju.
          </motion.p>
          <button
            className="about-scroll-btn"
            onClick={() =>
              document.querySelector(".about-extra").scrollIntoView({
                behavior: "smooth",
              })
            }
          >
            <span className="arrow"></span>
          </button>
        </div>
      </section>


      <section className="about-extra">
        <div className="about-extra__container">

          <div className="about-block">
            <h2>Dlaczego weryfikacja motocykla przed kupnem to konieczność?</h2>
            <ul>
                <li><strong>Ogłoszenia potrafią mylić</strong> – piękne zdjęcia i lakoniczny opis nie pokażą drobnych wycieków, luzów w zawieszeniu czy wyeksploatowanego napędu.</li>
                <li><strong>Maszyna ma historię</strong> – każdy motocykl „opowiada” o sobie: ślady korozji na śrubach, przebarwienia spawów, poluzowane łożyska. Trzeba je umieć zauważyć i zinterpretować.</li>
                <li><strong>Koszt napraw może zaskoczyć</strong> – wymiana zestawu rozrządu, zużyte tarcze hamulcowe, opony „na drutach” – to łatwo przeoczyć, a rachunek może sięgnąć tysięcy złotych.</li>
            </ul>
            <p><strong>Krótko mówiąc:</strong> zamiast opierać się na intuicji sprzedającego, 
                lepiej mieć obok siebie mechanika, który widział już setki podobnych motocykli, 
                zna ich bolączki i dokładnie wie, gdzie zajrzeć.</p>
          </div>
          <div className="about-block">
            <h2>Co zyskasz, gdy pojedziesz z PRO MOTO?</h2>
            <ol>
              <li><strong>Pełną diagnostykę mechanika-praktyka</strong> – oglądamy silnik endoskopem, mierzymy kompresję, sprawdzamy luzy zaworowe* (jeśli możliwe bez demontażu), oceniamy zawieszenie, hamulce i elektrykę pokładową.</li>
              <li><strong>Rzeczową wycenę „koszyka napraw”</strong> – w ciągu kilkunastu minut podliczamy, ile będziesz musiał zainwestować, by motocykl był w pełni sprawny i bezpieczny.</li>
              <li><strong>Wsparcie negocjacyjne </strong> – sprzedający słyszy fachowy język i konkretne argumenty; obniżka ceny to nasza codzienność.</li>
            </ol>
            <p>
                * pomiar luzów zaworowych dotyczy tylko modeli, w których producent umożliwia kontrolę bez zdejmowania pokryw zaworów
            </p>
          </div>
          <div className="about-block">
            <h2>Jak przebiega nasza usługa?</h2>
            <ol>
              <li><strong>Rezerwacja terminu</strong> <br/>Dzwonisz lub piszesz, podając lokalizację motocykla, markę i rocznik. Możemy wyruszyć z Mrowina koło Poznania tego samego dnia albo umówić się w dowolnym mieście w powiecie poznańskim.</li>
              <li><strong>Przygotowanie narzędzi</strong> <br/>Bierzemy endoskop, kompresometr, testery elektryki, grubościomierz lakieru, miernik napięcia, a także zestaw kluczy, aby sprawdzić newralgiczne punkty.</li>
              <li><strong>Spotkanie ze sprzedającym</strong> <br/>Przyjeżdżamy z Tobą lub osobno – w zależności od ustaleń. Rozmawiamy ze sprzedającym, zbieramy historię serwisową i wszystkie rachunki.</li>
              <li><strong>Diagnostyka i jazda próbna</strong> <br/>Oglądamy motocykl na postoju, uruchamiamy zimny silnik (to kluczowy moment!), sprawdzamy reakcję skrzyni biegów, hamulców i zawieszenia w trakcie krótkiej jazdy.</li>
              <li><strong>Raport i decyzja</strong> <br/> Po 20–30 minutach masz przed sobą jasną listę usterek, orientacyjny koszt napraw i rekomendację: kupić, negocjować dalej lub podziękować i szukać innego egzemplarza.</li>
            </ol>
          </div>
          <div className="about-block">
            <h2>Na co zwracamy szczególną uwagę?</h2>
            <ul>
                <li><strong>Silnik</strong> – wycieki, dźwięki rozrządu, kolor spalin, praca na wolnych obrotach.</li>
                <li><strong>Zawieszenie</strong> – uszczelniacze lag, sworznie wahacza, tylne amortyzatory, ugięcie sprężyn.</li>
                <li><strong>Układ hamulcowy</strong> – grubość tarcz, zużycie klocków, stan przewodów gumowych/metalowych.</li>
                <li><strong>Napęd</strong> – luz łańcucha, zęby zębatek, luzy przekładni końcowej w kardanie.</li>
                <li><strong>Układ chłodzenia</strong> – barwa płynu, ewentualne wycieki, praca wentylatora.</li>
                <li><strong>Lakier i rama</strong> – grubość powłoki (lakier liczony w mikronach), prostolinijność ramy, ślady po szlifach.</li>
            </ul>
          </div>
          <div className="about-block">
            <h2>Obszar działania – Poznań + wielkopolska</h2>
            <p>
                Choć bazujemy przy ul. Dworcowej 11 w Mrowinie, 
                jeździmy po motocykle w radiusie 80 km bez dopłaty kilometrowej. 
                Województwo wielkopolskie – ustalimy dogodny dzień i zrobimy wspólne oględziny.
            </p>
          </div>
          <div className="about-block about-block--final">
            <h2>FAQ – najczęstsze pytania</h2>
            <ul>
                <p>
                    <strong>Czy mogę zamówić tylko raport, bez negocjacji?</strong> <br/>
                    Oczywiście. Jeśli nie chcesz, abyśmy prowadzili rozmowę cenową, po prostu przekazujemy Ci dane techniczne.
                </p>
                <p>
                    <strong>A co, jeśli motocykl okaże się wadliwy?</strong> <br/>
                    Dowiesz się o tym na miejscu i zdecydujesz, czy rezygnujemy, czy negocjujemy cenę, uwzględniając koszty napraw.
                </p>
                <p>
                    <strong>Czy mogę wykonać usługę zdalnie?</strong> <br/>
                    Tak: jedziemy sami, robimy zdjęcia, film, raport PDF i dzwonimy z podsumowaniem. Idealne, gdy motocykl stoi 100 km od Ciebie
                </p>
                <p>
                    <strong>Ile to kosztuje?</strong> <br/>
                    Cena zależy od odległości i modelu, ale zazwyczaj zwraca się już przy pierwszej udanej negocjacji ceny. Szczegóły podajemy telefonicznie – wystarczy krótki opis motocykla i lokalizacja.
                </p>
                
            </ul>
          </div>
          <div className="about-block about-block--final">
            <h2>Zarezerwuj swój termin już dziś</h2>
            <ul>
                <p>
                    Zadzwoń pod <strong>+48 535 744 816</strong> albo wypełnij formularz – oddzwonimy jeszcze tego samego dnia. PRO MOTO pomoże Ci kupić motocykl, który cieszy.
                </p>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};



export default MotorcycleConsulting;